/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import Component from 'can/component/component';
import template from './tikcets-and-hospitality.stache';
import appContext from 'scripts/app-context';
import DomEventsManager from 'scripts/dom-events-manager';
import Swiper from 'swiper';

const inWebView = window.globalSettings.inWebView;

Component.extend({
    tag: 'tickets-and-hospitality',
    template,
    viewModel: {
        define: {
            hideSwiperArrows: {
                get() {
                    return (
                        ['medium', 'small', 'extra-small'].indexOf(
                            appContext.model.screen.attr('screenSize'),
                        ) > -1 || inWebView
                    );
                },
            },
            promoTitle: {
                type: 'string',
                value: '',
            },
            cards: {
                Type: can.List,
                Value: [],
            },
        },
    },
    events: {
        inserted(element) {
            DomEventsManager.subscribe(this);
            this.$swiperContainer = element.find('.swiper-container');
            this.initSwiper(appContext.model.screen.screenSize);
        },

        onWindowResize() {
            this.initSwiper(appContext.model.screen.screenSize);
        },

        getSwiperOptions(screen) {
            let slidesPerView = 3;
            let slidesPerColumn = 1;
            let spaceBetween = 32;

            switch (screen) {
                case 'extra-large':
                    slidesPerView = 3;
                    slidesPerColumn = 1;
                    spaceBetween = 32;
                    break;
                case 'large':
                    slidesPerView = 3;
                    slidesPerColumn = 1;
                    break;
                case 'medium':
                    slidesPerView = 2;
                    slidesPerColumn = 1;
                    break;
                case 'small':
                    slidesPerView = 1;
                    slidesPerColumn = 1;
                    break;
                case 'extra-small':
                    slidesPerView = 1;
                    slidesPerColumn = 1;
                    break;
            }

            return {
                watchSlidesVisibility: true,
                slidesPerView,
                slidesPerColumn,
                slidesPerGroup: 1,
                spaceBetween,
                simulateTouch: true,
                speed: 1000,
                pagination: {
                    el: this.$swiperContainer.find('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    prevEl: this.$swiperContainer
                        .closest('.js-swiper')
                        .find('.prev'),
                    nextEl: this.$swiperContainer
                        .closest('.js-swiper')
                        .find('.next'),
                },
            };
        },

        initSwiper(screen) {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
            let options = this.getSwiperOptions(screen);
            this.swiper = new Swiper(this.$swiperContainer, options);
            if (this.swiper.bullets && this.swiper.bullets.length <= 1) {
                this.$swiperContainer.find('.swiper-pagination').hide();
            }
        },
    },
});
